import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { NeedHelpChoiceTree } from 'Douleutaras/types';
import { makeRequest } from 'Douleutaras/services/apiClient';
import {
  AllModalOptions,
  NEED_HELP_MILESTONES
} from 'Douleutaras/constants/ccf/need-help-options';
import { CustomerFlowSlug } from 'Douleutaras/functional-components/ccf/CCFModals';

interface NeedHelpEndpointArgs {
  jobId: string | number;
  bidId?: string | number;
}
const endpoint = ({ jobId, bidId }: NeedHelpEndpointArgs) => {
  if (bidId) {
    return `api/public/v3/job/${jobId}/bids/${bidId}/need-help-choice-records/`;
  }

  return `api/public/v3/job/${jobId}/need-help-choice-records/`;
};

type NeedHelpSaveEndpointArgs = NeedHelpEndpointArgs & {
  buyerChoice: AllModalOptions;
  journeyStage: NEED_HELP_MILESTONES;
  parentOptionSlug?: AllModalOptions;
  sellerId?: string;
  customerFlow: CustomerFlowSlug;
};

export const getNeedHelpOptions = createAsyncThunk(
  'ccf/needHelpOptions',
  async ({ jobId, bidId }: NeedHelpEndpointArgs, api) => {
    const response = await makeRequest(endpoint({ jobId, bidId }), {
      method: 'OPTIONS'
    })(api);

    return response.data.data.needHelpChoiceTree;
  }
);

export const getNeedHelpSave = createAsyncThunk<NeedHelpChoiceTree, NeedHelpSaveEndpointArgs>(
  'ccf/needHelpSave',
  async ({ jobId, bidId, buyerChoice, journeyStage, parentOptionSlug, sellerId, customerFlow }, api) => {
    const attributes = {
      buyerChoice,
      customer_journey_stage: journeyStage,
      parentBuyerChoice: parentOptionSlug,
      customerFlow
    };
    if (sellerId) {
      attributes['extra_data'] = { notification_seller_id: parseInt(sellerId, 0) };
    }
    const response = await makeRequest(endpoint({ jobId, bidId }), {
      method: 'POST',
      body: {
        data: {
          type: 'need-help-choice-records',
          attributes
        }
      }
    })(api);

    return response.data.data.needHelpChoiceTree;
  }
);

export const needHelpOptionsSlice = createSlice({
  name: 'needHelpOptionsSlice',
  initialState: {} as NeedHelpChoiceTree,
  reducers: {},
  extraReducers: builder => {
    builder.addCase(getNeedHelpOptions.fulfilled, (state, action) => {
      return action.payload;
    });
  }
});

export default needHelpOptionsSlice;
